import { Component, input, output } from '@angular/core';
import { AutomaticallyPlannedRide, Particularity } from 'src/app/interfaces';
import moment from 'moment';
import { dataStore } from 'src/app/app.component';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIconButton } from '@angular/material/button';

@Component({
  selector: 'app-auto-plan-item',
  templateUrl: './auto-plan-item.component.html',
  styleUrls: ['./auto-plan-item.component.scss'],
  imports: [MatIcon, MatTooltip, MatIconButton],
})
export class AutoPlanItemComponent {
  ride = input<AutomaticallyPlannedRide | undefined>(undefined);
  itemClicked = output<void>();
  deleteClicked = output<void>();

  moment = moment;
  particularities: Particularity[] = dataStore.selectedOrganisation.particularities ?? [];

  constructor() {}

  onItemClick() {
    this.itemClicked.emit();
  }

  onDeleteClick() {
    this.deleteClicked.emit();
  }

  getRideColor(): string {
    // You can customize this based on ride status, priority, etc.
    return this.ride()?.useBuffers ? '#6c5ce7' : '#ff9800';
  }

  getParticularityIcon(particularityId: string): string {
    const iconMap: { [key: string]: string } = {
      wheelchair: 'accessible',
      companion: 'supervisor_account',
      guide_dog: 'pets',
      oxygen: 'local_hospital',
      walker: 'accessibility_new',
      // Add more mappings as needed based on your particularities
    };

    return iconMap[particularityId] || 'help_outline';
  }
}
